/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationSettingDto } from './locationSettingDto';


export interface LocationSettingDtoPagedResultDto { 
    items?: Array<LocationSettingDto> | null;
    totalCount?: number;
}

